/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import browser from "../utils/browser";

import style from "../dom/style";
import factory from "../dom/factory";

/*
 Selectors used
 */
var INNER_WRAPPER_SELECTOR = ".scrollable-area-inner-wrapper";
var CONTENT_SELECTOR = ".scrollable-area-content";
var SCROLLBAR_THUMB_SELECTOR = ".scrollbar-thumb";

/*
 Scrollbar UI HTML
 */
var SCROLLBAR_HTML =
    '<div class="scrollbar-track hidden"><div class="scrollbar-thumb"></div></div>';

export default baustein.register("scrollable-area", {
    init() {
        // This is the inner wrapper that is scrollable using good ol' overflow:scroll
        // This is what we listen to on scroll.
        this.innerWrapper = this.el.querySelector(INNER_WRAPPER_SELECTOR);

        this.render();
    },

    setupEvents(add) {
        // If we are on webkit we don't have to do anything.
        if (browser.supportsCSSScrollbars) {
            return;
        }

        add("scroll", INNER_WRAPPER_SELECTOR, this._onScroll);
        add("mousedown", SCROLLBAR_THUMB_SELECTOR, this._onMousedown);
    },

    onRemove() {
        this.releaseGlobalHandler("mouseup", this._onMouseup);
        this.releaseGlobalHandler("mousemove", this._onMousemove);
    },

    /*
     Appends the scroll UI. This is called once on instantiation. Note: by default
     the scroll ui is hidden. All this does is append it and save references
     to the scrollbar UI elements for later use.
     */
    render() {
        // If we are on webkit we don't have to do anything.
        if (!browser.supportsCSSScrollbars && !this.scrollbar) {
            this.scrollbar = factory.fromString(SCROLLBAR_HTML);
            this.el.appendChild(this.scrollbar);

            this.scrollbarThumb = this.scrollbar.querySelector(SCROLLBAR_THUMB_SELECTOR);
        }

        this._detectAndSetInfo();

        // If there isn't any overflow hide it and gtfo
        if (this.wrapperHeight >= this.contentHeight) {
            this.hideScrollbar();
        } else {
            this.showScrollbar();
        }
    },

    /*
     For the scrolling behavior to work, there are a number of details
     we need. This sets all of these details on the instace.
     */
    _detectAndSetInfo() {
        this.wrapperHeight = this.el.clientHeight;
        this.contentHeight = this.el.querySelector(CONTENT_SELECTOR).clientHeight;

        if (this.wrapperHeight === 0 || this.contentHeight === 0) {
            this.scrollbarThumbHeight = 0;
            this.maxScrollbarThumbTop = 0;
            return;
        }

        // This is the height of the scroll position indicator (a.k.a. 'thumb')
        // It's height is relative to the content height and the wrapper height.
        this.scrollbarThumbHeight = (this.wrapperHeight / this.contentHeight) * this.wrapperHeight;

        // This value represents the maximum css 'top' value the scrollbar thumb can have in px.
        this.maxScrollbarThumbTop = this.wrapperHeight - this.scrollbarThumbHeight;
    },

    /*
     Positions the scrollbar thumb.
     */
    _positionScrollbarThumb(pxPosition) {
        var max = this.maxScrollbarThumbTop;
        var min = 0;

        // This crazy statement basically just makes sure the scrollbar handle
        // is never moved outside of the scrollbar track.
        var pxTop = pxPosition > max ? max : pxPosition < min ? min : pxPosition;

        style.setStyle(this.scrollbarThumb, "top", pxTop);
    },

    /*
     Shows the scrollbar
     */
    showScrollbar() {
        if (!browser.supportsCSSScrollbars) {
            this.scrollbar.classList.remove("hidden");
            style.setStyle(this.scrollbarThumb, "height", this.scrollbarThumbHeight);
        }
        style.setStyle(this.el, "height", this.wrapperHeight);
        style.setStyle(this.innerWrapper, "overflow-y", "scroll");
    },

    /*
     Hides the scrollbar
     */
    hideScrollbar() {
        if (!browser.supportsCSSScrollbars) {
            this.scrollbar.classList.add("hidden");
        }
        style.setStyle(this.el, "height", "auto");
        style.setStyle(this.innerWrapper, "overflow-y", "visible");
    },

    /*
     Scroll event listener
     */
    _onScroll() {
        var scrollTop = this.innerWrapper.scrollTop;
        var percentScrolled = scrollTop / this.contentHeight;

        // This value represents the number of px the percentage scrolled
        // corresponds too based on the scrollable area height
        var relativePxScrolled = this.wrapperHeight * percentScrolled;

        this._positionScrollbarThumb(relativePxScrolled);
    },

    /*
     Mousedown event handler for clicks on the scrollbar thumb
     */
    _onMousedown(event) {
        event.preventDefault();

        this.mousedownYPosition = event.pageY;
        this.mousedownScrollTop = this.innerWrapper.scrollTop;

        this.setGlobalHandler("mouseup", this._onMouseup);
        this.setGlobalHandler("mousemove", this._onMousemove);
    },

    /*
     Mousemove event handler for dragging the scrollbar thumb. This is bound
     before when mousedown and is unbound on mouseup of the scrollbar thumb.
     */
    _onMousemove(event) {
        // The number of px dragged for
        var pxDragged = event.pageY - this.mousedownYPosition;

        // 1 sidebar px scroll corresponds to this much scrolling of the content
        var pxToScrollRatio = this.contentHeight / this.wrapperHeight;

        // How many pixels should you scroll for
        var scrollBy = pxToScrollRatio * pxDragged + this.mousedownScrollTop;
        this.innerWrapper.scrollTop = scrollBy;
    },

    /*
     Mouseup handler for the scrollbar thumb. It's important to unbind the
     mousemove event, otherwise it will keep doing lot's of expensive stuff.
     */
    _onMouseup() {
        this.releaseGlobalHandler("mouseup", this._onMouseup);
        this.releaseGlobalHandler("mousemove", this._onMousemove);
    },

    /*
     Returns the scroll position
     */
    getPosition() {
        return this.innerWrapper.scrollTop;
    },

    /*
     Sets the scroll position
     */
    setPosition(newPosition) {
        this.innerWrapper.scrollTop = newPosition;
    }
});

